import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { APIErrorVM, AuthErrorAction, CmSystemEvent } from '../models/system-event';

@Injectable({
	providedIn: 'root',
})
export class CmEventService {
	private readonly event = new Subject<CmSystemEvent>();
	public readonly event$ = this.event.asObservable();
	constructor() {}

	handleAPIError({ guid, id, message }: APIErrorVM): void {
		this.event.next({
			id: guid ?? id,
			type: 'API_ERROR',
			raw: { guid, id, message },
		});
	}

	handleSystemError(id: string = 'system-error'): void {
		this.event.next({ id, type: 'SYSTEM_ERROR' });
	}

	handleAuthError(id: string = 'auth-error', action?: AuthErrorAction): void {
		this.event.next({ id, type: 'AUTH_ERROR', action });
	}

	handleLoadingChange(id: string, status: 'START' | 'END' = 'START'): void {
		this.event.next({
			id,
			type: status === 'END' ? 'LOAD_END' : 'LOAD_START',
		});
	}

	requireReload(): void {
		this.event.next({ id: 'reload-required', type: 'RELOAD_REQUIRED' });
	}
}
